import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeIn, Container, SectionDivider } from "@/components/Section";

/**
 * "What's next in your TOK journey?" — universal cross-link block.
 * Placed at the bottom of programme/experience pages to guide visitors deeper
 * into the ecosystem instead of dead-ending.
 */
export default function NextStepsBlock({
  title = "Continue the journey",
  eyebrow = "What's next",
  steps = [],
}) {
  if (!steps?.length) return null;
  return (
    <>
      <SectionDivider label={eyebrow} />
      <Container className="pb-24">
        <div className="max-w-3xl mb-10">
          <p className="tok-eyebrow">{eyebrow}</p>
          <h2 className="tok-headline-xl mt-3">
            {title.split(" ").slice(0, -1).join(" ")}{" "}
            <span className="text-amber-400">
              {title.split(" ").slice(-1)}
            </span>
          </h2>
        </div>
        <div
          className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3"
          data-testid="next-steps-block"
        >
          {steps.map((s, i) => (
            <FadeIn key={s.to + s.title} delay={i * 0.05}>
              <Link
                to={s.to}
                data-testid={`next-step-${s.testid || i}`}
                className="group block h-full p-6 sm:p-7 border border-white/10 bg-zinc-950 hover:border-amber-400/50 hover:bg-amber-400/5 transition-all"
              >
                <p className="tok-eyebrow-sm">{s.label}</p>
                <h3 className="tok-headline-md mt-3 leading-tight text-lg">
                  {s.title}
                </h3>
                {s.desc && (
                  <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                    {s.desc}
                  </p>
                )}
                <div className="mt-5 inline-flex items-center gap-2 tok-cta-label text-amber-400 group-hover:gap-4 transition-all">
                  {s.cta || "Enter"}
                  <ArrowRight className="h-3 w-3" />
                </div>
              </Link>
            </FadeIn>
          ))}
        </div>
      </Container>
    </>
  );
}
